import services from "../services/api";

const api = services.apiV1

const BrandRepository = {
  async getBrands() {
    const data = await api.get(`brands/os-digital`);
    return data?.data || [];
  },

  async getModelsByDescription(brand) {
    const data = await api.get(`brands/by-description/os-digital/${brand}`);
    return data?.data || [];
  },
};

export default BrandRepository;
